import {Partner} from "../sdk/models";

export class IPartner extends Partner {

  public static readonly FIELDS: Array<string> = [
    'id',
    'active',
    'name',
    'street',
    'street2',
    'zip',
    'country_id',
    'city',
    'state_id',
    'residue_partner',
    'partner_ler_product_list',
    'comercial',
    "ler_operator_type_id"
  ];

  public static readonly FILTER_INCLUDE: any = null;

  public static readonly FILTER_INCLUDE_LER_PRODUCTS: any = [
    {
      "relation": "products",
      "scope": {
        "fields": ["id", "name", "product_id", "state"],
        "where": {
          "state": "active"
        },
        "include": [
          {
            "relation": "product",
            "scope": {
              "fields": ["id", "uom_id", "uom_po_id", "name"],
              "include": [
                {
                  "relation": "uom",
                  "scope": {"fields": ["id", "name"]}
                },
                {
                  "relation": "uom_po",
                  "scope": {"fields": ["id", "name"]}
                }
              ]
            }
          }
        ]
      }
    }, {
      "relation": "ler_operator_type",
      "scope": {
        "fields": ["id", "name"]
      }
    },

  ];

  public static readonly FILTER_WHERE: any = {supplier:true, residue_partner: true};

  constructor(json: Partner) {
    super(json);
  }
}


// WEBPACK FOOTER //
// ./src/models/IPartner.ts